/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type BoundaryNodeDataCenter = {
  /**
   * Longitude
   */
  longitude?: string | undefined;
  /**
   * Latitude
   */
  latitude?: string | undefined;
  /**
   * Total Nodes
   */
  totalNodes?: string | undefined;
  /**
   * Owner
   */
  owner?: string | undefined;
  /**
   * Region
   */
  region?: string | undefined;
  /**
   * Name
   */
  name?: string | undefined;
  /**
   * Data Center ID
   */
  dcId?: string | undefined;
};

/** @internal */
export const BoundaryNodeDataCenter$inboundSchema: z.ZodType<
  BoundaryNodeDataCenter,
  z.ZodTypeDef,
  unknown
> = z.object({
  longitude: z.string().optional(),
  latitude: z.string().optional(),
  total_nodes: z.string().optional(),
  owner: z.string().optional(),
  region: z.string().optional(),
  name: z.string().optional(),
  dc_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "total_nodes": "totalNodes",
    "dc_id": "dcId",
  });
});

/** @internal */
export type BoundaryNodeDataCenter$Outbound = {
  longitude?: string | undefined;
  latitude?: string | undefined;
  total_nodes?: string | undefined;
  owner?: string | undefined;
  region?: string | undefined;
  name?: string | undefined;
  dc_id?: string | undefined;
};

/** @internal */
export const BoundaryNodeDataCenter$outboundSchema: z.ZodType<
  BoundaryNodeDataCenter$Outbound,
  z.ZodTypeDef,
  BoundaryNodeDataCenter
> = z.object({
  longitude: z.string().optional(),
  latitude: z.string().optional(),
  totalNodes: z.string().optional(),
  owner: z.string().optional(),
  region: z.string().optional(),
  name: z.string().optional(),
  dcId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    totalNodes: "total_nodes",
    dcId: "dc_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace BoundaryNodeDataCenter$ {
  /** @deprecated use `BoundaryNodeDataCenter$inboundSchema` instead. */
  export const inboundSchema = BoundaryNodeDataCenter$inboundSchema;
  /** @deprecated use `BoundaryNodeDataCenter$outboundSchema` instead. */
  export const outboundSchema = BoundaryNodeDataCenter$outboundSchema;
  /** @deprecated use `BoundaryNodeDataCenter$Outbound` instead. */
  export type Outbound = BoundaryNodeDataCenter$Outbound;
}

export function boundaryNodeDataCenterToJSON(
  boundaryNodeDataCenter: BoundaryNodeDataCenter,
): string {
  return JSON.stringify(
    BoundaryNodeDataCenter$outboundSchema.parse(boundaryNodeDataCenter),
  );
}

export function boundaryNodeDataCenterFromJSON(
  jsonString: string,
): SafeParseResult<BoundaryNodeDataCenter, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BoundaryNodeDataCenter$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BoundaryNodeDataCenter' from JSON`,
  );
}
